/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/extensions */
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styleBPE.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify, Auth } from 'aws-amplify';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import ErrorBoundary from './components/Common/ErrorBoundary/index';
import { inAffiliateReferrerClicks } from './containers/actions/admin_actions';
import { getDefaultSelectedCompany, getSelectedCompanyId, parseCompanyData, getCompanyHeader } from './utils/companyDataUtils';

// Extend Window interface for ApexCharts polyfill
declare global {
	interface Window {
		resolve?: (value: any) => Promise<any>;
	}
}

// Extend Window interface for ApexCharts polyfill
declare global {
	interface Window {
		resolve?: (value: any) => Promise<any>;
	}
}

const url = new URL(window.location.href);
const accesCode = url.searchParams.get('code');

if (url.pathname === '/profileSettings/socialMediaIntegration' && accesCode)
{
	// for linkedin redirection
	window.opener.postMessage({ code: accesCode }, url?.origin);
	window.close();
}

const customHeader = async () =>
{
	try
	{
		const user = await Auth.currentAuthenticatedUser();
		const companyList = parseCompanyData(user?.attributes?.['custom:companyData']);
		const selectedCompany = getDefaultSelectedCompany(companyList, getSelectedCompanyId());

		return getCompanyHeader(selectedCompany?.companyId || user?.attributes?.['custom:companyId']);
	}
	catch (error)
	{
		return null;
	}
};

const cookieDomain = process.env.REACT_APP_COOKIE_DOMAIN;
const enableCookieSso = Boolean(cookieDomain) &&
	window?.location?.protocol === 'https:' &&
	window?.location?.hostname.endsWith((cookieDomain || '').replace(/^\./, ''));

Amplify.configure({
	Auth : {
		mandatorySignIn     : true,
		identityPoolId      : process.env.REACT_APP_IDENTITY_POOL_ID,
		region              : process.env.REACT_APP_AP_SOUTHEAST_ONE,
		userPoolId          : process.env.REACT_APP_USER_POOL_ID,
		userPoolWebClientId : process.env.REACT_APP_APP_CLIENT_ID,
		...(enableCookieSso
			? {
				cookieStorage : {
					domain   : cookieDomain,
					path     : '/',
					expires  : 365,
					secure   : true,
					sameSite : 'lax'
				}
			}
			: {})
	},
	// Auth : {
	// 	mandatorySignIn     : true,
	// 	region              : process.env.REACT_APP_AP_SOUTH_ONE,
	// 	userPoolId          : process.env.REACT_APP_USER_POOL_ID,
	// 	identityPoolId      : process.env.REACT_APP_IDENTITY_POOL_ID,
	// 	userPoolWebClientId : process.env.REACT_APP_APP_CLIENT_ID
	// oauth               : {
	// 	domain          : process.env.REACT_APP_COGNITO_DOMAIN,
	// 	scope           : [ 'email', 'openid', 'phone', 'profile', 'aws.cognito.signin.user.admin' ],
	// 	redirectSignIn  : window.location.origin, // change redirection url as per as aws added sigin url list (sign out in login page in aws app clients need to add)
	// 	redirectSignOut : window.location.origin, // change redirection url as per as aws added sigout url list (sign out in login page in aws app clients need to add)
	// 	responseType    : 'code',
	// 	debug           : true

	// }
	// },
	API : {
		endpoints : [ {
			name          : 'userManagement',
			endpoint      : process.env.REACT_APP_USER,
			region        : process.env.REACT_APP_US_EAST_ONE,
			custom_header : customHeader

		},
		{
			name          : 'ssoUserManagement',
			endpoint      : process.env.REACT_APP_INSTAVC_USER_SSO,
			region        : process.env.REACT_APP_AP_SOUTHEAST_ONE,
			custom_header : customHeader
		},
		{
			name          : 'revisedResources',
			endpoint      : process.env.REACT_APP_REVISED_RESOURCES_SSO,
			region        : process.env.REACT_APP_US_EAST_ONE,
			custom_header : customHeader
		},
		{
			name          : 'contentManagement',
			endpoint      : process.env.REACT_APP_CONTENT,
			region        : process.env.REACT_APP_US_EAST_ONE,
			custom_header : customHeader
		}, {
			name          : 'departments',
			endpoint      : process.env.REACT_APP_CONFIG,
			region        : process.env.REACT_APP_US_EAST_ONE,
			custom_header : customHeader
		}, {
			name          : 'feedsManagement',
			endpoint      : process.env.REACT_APP_FEED,
			region        : process.env.REACT_APP_US_EAST_ONE,
			custom_header : customHeader
		}, {
			name          : 'connectionManagement',
			endpoint      : process.env.REACT_APP_CONNECTION,
			region        : process.env.REACT_APP_US_EAST_ONE,
			custom_header : customHeader
		},
		{
			name          : 'ssoChat',
			endpoint      : process.env.REACT_APP_CHAT,
			region        : process.env.REACT_APP_US_EAST_ONE,
			custom_header : customHeader
		},
		{
			name          : 'notification',
			endpoint      : process.env.REACT_APP_NOTIFICATION,
			region        : process.env.REACT_APP_US_EAST_ONE,
			custom_header : customHeader
		},
		{
			name          : 'taskManagement',
			endpoint      : process.env.REACT_APP_TASK,
			region        : process.env.REACT_APP_US_EAST_ONE,
			custom_header : customHeader
		},
		{
			name          : 'folderManagement',
			endpoint      : process.env.REACT_APP_MEDIADRIVE,
			region        : process.env.REACT_APP_US_EAST_ONE,
			custom_header : customHeader
		},
		{
			name          : 'resourceManagement',
			endpoint      : process.env.REACT_APP_RESOURCE,
			region        : process.env.REACT_APP_US_EAST_ONE,
			custom_header : customHeader

		},
		{
			name          : 'InVcMainchat',
			endpoint      : process.env.REACT_APP_TW_INVCPOSTSOCKETBROADCASRCHAT,
			region        : process.env.REACT_APP_AP_SOUTHEAST_ONE,
			custom_header : customHeader
		},
		{
			name          : 'trainingWebinarPoll',
			endpoint      : process.env.REACT_APP_TW_POLLHISTORY,
			region        : process.env.REACT_APP_AP_SOUTH_TWO,
			custom_header : customHeader
		},
		{
			name          : 'twRecordings',
			endpoint      : process.env.REACT_APP_TW_RECORDING,
			region        : process.env.REACT_APP_AP_SOUTHEAST_ONE,
			custom_header : customHeader
		},
		{

			name          : 'analytics',
			endpoint      : process.env.REACT_APP_ANALYTICS,
			region        : process.env.REACT_APP_US_EAST_ONE,
			custom_header : customHeader

		},
		{
			name          : 'bussinessManagement',
			endpoint      : process.env.REACT_APP_BUSSINESSPROSPECTS,
			region        : process.env.REACT_APP_US_EAST_ONE,
			custom_header : customHeader
		},
		{
			name     : 'pastmeetingrecording',
			endpoint : process.env.REACT_APP_PASSMEETINGS_INMEET,
			region   : process.env.REACT_APP_AP_SOUTH_ONE
			// custom_header : customHeader
		},
		{
			name     : 'inmeetAanalytics',
			endpoint : process.env.REACT_APP_INMEET,
			region   : process.env.REACT_APP_US_EAST_ONE
			// custom_header : customHeader
		},
		{
			name          : 'inAffiliate',
			endpoint      : process.env.REACT_APP_POST_INAFFILIATE_API,
			region        : process.env.REACT_APP_US_EAST_ONE,
			custom_header : customHeader
		},
		{
			name          : 'presenceManagement',
			endpoint      : process.env.REACT_APP_PRESENCE_TOKEN_API,
			region        : process.env.REACT_APP_PRESENCE_US_REGION,
			custom_header : async () =>
			{ // Add this for automatic token handling
				const session = await Auth.currentSession();

				return {
					'presence-authorization' : `Bearer ${session?.getIdToken()?.getJwtToken()}`,
					'x-product-name'         : 'InLynk'
				};
			}
		},
		{
			name          : 'resourceManagementVPP',
			endpoint      : process.env.REACT_APP_REVISED_RESOURCE_VPP,
			region        : process.env.REACT_APP_US_EAST_ONE,
			custom_header : customHeader
		},
		{
			name          : 'resourceManagementADI',
			endpoint      : process.env.REACT_APP_REVISED_RESOURCE_ADI,
			region        : process.env.REACT_APP_US_EAST_ONE,
			custom_header : customHeader
		},
		{
			name          : 'resourceManagementGraphQL',
			endpoint      : process.env.REACT_APP_REVISED_RESOURCE_GRAPHQL,
			region        : process.env.REACT_APP_US_EAST_ONE,
			custom_header : customHeader
		}
		]
	}
});

const getQueryParam = (refferName) =>
{
	const urlParams = new URLSearchParams(window?.location?.search);

	return urlParams?.get(refferName);
};
const AppWithReferrer = () =>
{
	useEffect(() =>
	{
		const checkReffererInaffiliate = async () =>
		{
			const referrer = getQueryParam('ref');

			if (referrer)
			{
				localStorage.setItem('referrer', referrer);

				const retryCallingApi = async (body, retriesCount = 3) =>
				{
					try
					{
						const response = await inAffiliateReferrerClicks(body);

						console.log(response);
					}
					catch (err)
					{
						if (retriesCount > 0)
						{
							return await retryCallingApi(body, retriesCount - 1);
						}
					}
				};

				try
				{
					const body = {
						userId      : referrer,
						productCode : process.env.REACT_APP_PRODUCT_CODE
					};

					await retryCallingApi(body);
				}
				catch (err)
				{
					console.log(err, '---------');
				}
			}
		};

		checkReffererInaffiliate();

		const handleNavigation = () =>
		{
			checkReffererInaffiliate();
		};

		window.addEventListener('popstate', handleNavigation);

		return () =>
		{
			window.removeEventListener('popstate', handleNavigation);
		};
	}, []);

	return (
		<Provider store={store}>
			<App />
		</Provider>
	);
};

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

// ApexCharts polyfill to fix "resolve is not defined" error
if (typeof window !== 'undefined' && !window.hasOwnProperty('resolve'))
{
	window.resolve = (value) =>
	{
		return Promise.resolve(value);
	};
}

root.render(
	<ErrorBoundary>
		{/* <Provider store={store}> */}
		<AppWithReferrer />
		{/* </Provider> */}
	</ErrorBoundary>
);

reportWebVitals();